import React, { ReactElement } from 'react';
import { Redirect, Route, RouteProps } from 'react-router';
import constVars from '~/constants/constVars';
import { useAuth } from './contexts/AuthContext/AuthProvider';

const ProtectedRoute = ({ ...props }: RouteProps): ReactElement => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Route {...props} />;
  }

  if (window.location.pathname !== constVars.ROUTE_DEFAULT) {
    const returnToValue = `${window.location.pathname}${window.location.search}`;
    sessionStorage.setItem('returnTo', returnToValue);
  }

  return <Redirect to={`/${constVars.ROUTE_LOGIN}`} />;
};

export default ProtectedRoute;
